import styled from "styled-components";
import MUIMenu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { breakpoints } from "@/styles/breakpoints";

export const StyledLanguagePopover = styled(MUIMenu).attrs(() => ({
    elevation: 0,
}))`
    .MuiMenu-paper {
        @media ${breakpoints.xs} {
            top: 50px !important;
            bottom: 0 !important;
            left: 0 !important;
            min-width: 100%;
            height: 100%;
            max-height: 100%;
            margin-top: 0;
        }
    }
    .MuiList-padding {
        padding-top: 0;
        padding-bottom: 0;
    }
    .MuiPopover-paper {
        box-sizing: border-box;
        background: var(--color-white);
        border: none;
        border-radius: var(--radius-5);
    }
    .popover-paper {
        max-height: "calc(90% - 96px)";
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15) !important;
    }
`;

export const StyledLanguageMenuItem = styled(MenuItem)`
    &.listitem-root {
        padding: 10px 20px;
        /* border-bottom: 2px solid var(--color-grey-500); MYBR-6930 */
        @media ${breakpoints.sm} {
            padding: 15px 20px;
        }
        &:last-child {
            border: none;
        }
        i {
            min-width: 30px;
            text-align: right;
        }
    }
`;
